<template>
  <div
    class="candidate-card shadow-level-1"
    v-if="!errorAccess"
    :data-id="fields && fields.id && fields.id.value ? fields.id.value : ''"
    v-loading="candidatePageLoading"
  >
    <Dialog
      v-if="is_visible.delete_dialog"
      title="Удалить кандидата"
      text="Вы действительно хотите удалить кандидата?"
      :is_visible="is_visible.delete_dialog"
      button-ok-color="blue"
      button-cancel-color="darkBlue"
      @ok-callback="deleteCandidate"
      @cancel-callback="closeDialog('delete_dialog')"
    />
    <CandidateConsideredDialog
      v-if="innerDialog.visible"
      :dialog="innerDialog"
      :visible.sync="innerDialog.visible"
      :status="status"
      @confirm="closeInnerDialog"
      @close="closeInnerDialog"
    />
    <share-by-candidate-dialog
      v-if="is_visible.share_candidate_in_telegram_dialog"
      :is_visible="is_visible.share_candidate_in_telegram_dialog"
      :data="{ id: fields.id.value, module }"
      @reset-callback="closeDialog('share_candidate_in_telegram_dialog')"
    ></share-by-candidate-dialog>
    <Dialog
      v-if="deletedVacancy"
      :is_visible="is_visible.relation_dialog"
      title="Открепить кандидата"
      :text="`Вы действительно хотите удалить связь с вакансией «${deletedVacancy.name}»?`"
      button-ok-color="blue"
      button-cancel-color="darkBlue"
      @ok-callback="confirmVacancyRemove"
      @cancel-callback="closeDialog('relation_dialog', null)"
    />

    <security-service
      v-if="is_visible.security_dialog"
      :is_visible="is_visible.security_dialog"
      @save="saveSecurityServiceData($event)"
      @close-popup="closeDialog('security_dialog', null, 'selectedStage')"
    />
    <corporate-email
      v-if="is_visible.corporate_email_dialog"
      :is_visible="is_visible.corporate_email_dialog"
      @save="saveCorpFrom"
      @close-popup="
        closeDialog('corporate_email_dialog', null, 'selectedStage')
      "
    />
    <rejection-dialog
      v-if="is_visible.rejection_dialog"
      type="rejection"
      :is_visible="is_visible.rejection_dialog"
      :modules="[MODULE.REJECTION_REASONS, MODULE.REJECTION_CATEGORIES]"
      @reset-callback="closeDialog('rejection_dialog', null, 'selectedStage')"
      @confirm="param => confirmRejectionData('rejection_dialog', param)"
      @add-config="addConfig"
    ></rejection-dialog>
    <rejection-dialog
      v-if="is_visible.no_rejection_dialog"
      type="return"
      :is_visible="is_visible.no_rejection_dialog"
      @reset-callback="
        closeDialog('no_rejection_dialog', null, 'selectedStage')
      "
      @confirm="param => confirmRejectionData('no_rejection_dialog', param)"
    ></rejection-dialog>
    <employee-exit-dialog
      v-if="is_visible.employee_exit_dialog"
      :is_visible="is_visible.employee_exit_dialog"
      :data="getExitData"
      :selected-stage="selectedStage"
      @reset-callback="
        closeDialog(
          ['employee_exit_dialog', 'stage_dialog', 'no_rejection_dialog'],
          null,
          'selectedStage',
          'vacancyForWindow'
        )
      "
      @confirm-stage-select="confirmStageSelect('employee_exit_dialog')"
    ></employee-exit-dialog>
    <offer-dialog
      v-if="is_visible.form_offer_dialog"
      :is_visible="is_visible.form_offer_dialog"
      :data="getOfferData"
      @reset-callback="
        closeDialog(
          ['form_offer_dialog', 'stage_dialog', 'no_rejection_dialog'],
          null,
          'selectedStage',
          'vacancyForWindow'
        )
      "
      @confirm-stage-select="confirmStageSelect('form_offer_dialog')"
    ></offer-dialog>
    <SaveResumeDialog
      v-if="is_visible.save_resume"
      :is_visible="is_visible.save_resume"
      :data="fields"
      @preload="preload"
      @reset-callback="closeDialog('save_resume')"
    />
    <ResumeDialog
      v-if="resumeText && is_visible.preload_resume"
      :is_visible="is_visible.preload_resume"
      :resume="formatHtml(resumeText)"
      mode="templateText"
      @reset-callback="is_visible.preload_resume = false"
    />
    <questionnaire-dialog
      v-if="is_visible.questionnaire_dialog && questionnaireData"
      :title="questionnaireData.title"
      :description="questionnaireData.description"
      :is_visible="is_visible.questionnaire_dialog"
      @cancel-callback="
        closeDialog('questionnaire_dialog', null, 'questionnaireData')
      "
    />
    <training-dialog
      v-if="is_visible.training_dialog && hasEmail.length"
      :is_visible="is_visible.training_dialog"
      :data="selectedStage"
      :emails="hasEmail"
      @close-popup="
        closeDialog(
          ['training_dialog', 'stage_dialog', 'no_rejection_dialog'],
          null,
          'selectedStage'
        )
      "
      @confirm-stage-select="confirmStageSelect('training_dialog')"
    ></training-dialog>
    <VacancyListForm
      v-if="is_visible.vacancies_popup"
      @set-loading="setLoading"
      @showNotification="showNewNotification"
      :candidateId="fields.id.value"
    />
    <div class="candidate-card__top" v-if="metaData && !candidatePageLoading">
      <form-buttons
        v-if="metaData && metaData.buttons_menu && metaData.buttons_menu.length"
        :buttons_menu="metaData.buttons_menu"
        :disabledBtns="disabledButtons"
        view-type="detail"
        class="candidate-card__top-buttons"
      ></form-buttons>
      <div
        class="candidate-card__top-close"
        v-if="metaData && metaData.buttons_menu && metaData.buttons_menu.length"
      >
        <Button
          buttonSize="small"
          buttonColor="transparent"
          buttonText=""
          iconColor="#788694"
          hasRightIcon
          iconName="Cross"
          style="width: 24px"
          @click="closeCard"
        />
      </div>
    </div>
    <div class="candidate-card__page scrollable-content">
      <Candidate
        v-if="metaData && fields && !candidatePageLoading"
        :buttons_menu="metaData.buttons_menu"
        :panels="metaData.panels"
        :fields="fields"
        :emails="hasEmail"
        :subpanels="
          metaData.subpanels && metaData.subpanels.panelColumn
            ? metaData.subpanels.panelColumn
            : []
        "
      />
    </div>
  </div>
</template>
<script>
// import 'Root/build.js';
// import 'Root/assets/scss/common.scss';
import { store } from '@/store';
import { eventBus } from '@/bus';
import Candidate from './Candidate';
import CandidateConsideredDialog from 'Elements/Dialog/CandidateConsideredDialog';

import { getController, postController } from '@/controllers/request.js';
import {
  MODULE,
  OFFER_STAGE,
  PREPARE_TO_EXIT_STAGE,
  STAGE_TYPE_FOR_EXIT_EMPLOYEE,
  SUBPANEL,
  EVENTBUS_EVENTS
} from '@/utils/constants';
import {
  mixin,
  dialogMixin,
  metadata,
  stage,
  errorMsg,
  detailViewPage,
  update,
  parseIntent
} from '@/utils/mixins';
import Dialog from 'Elements/Dialog/Dialog';
import EmployeeExitDialog from 'Elements/Dialog/EmployeeExitDialog';
import OfferDialog from 'Elements/Dialog/OfferFormationDialog';
import RejectionDialog from 'Elements/Dialog/RejectionDialog';
import ShareByCandidateDialog from 'Elements/Dialog/ShareByCandidateDialog';
import SecurityService from 'Elements/Dialog/SecurityService';
import CorporateEmail from 'Elements/Dialog/CorporateEmail';
import VacancyListForm from 'Elements/Dialog/VacancySelectionDialog';
import SaveResumeDialog from 'Elements/Dialog/SaveResumeDialog';
import ResumeDialog from 'Elements/Dialog/ResumeDialog';
import TrainingDialog from 'Elements/Dialog/TrainingDialog';
import QuestionnaireDialog from 'Elements/Dialog/QuestionnaireDialog';
import FormButtons from 'Elements/Form/FormButtons';
import Button from 'Elements/Button/Button';

export default {
  mixins: [
    mixin,
    dialogMixin,
    metadata,
    stage,
    errorMsg,
    detailViewPage,
    update,
    parseIntent
  ],
  props: {
    candidateFields: {
      type: Object
    },
    mod: {
      type: Object
    },
    candidateId: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },

    previewAllowed: {
      type: Boolean,
      default: false
    },
    config: Object,
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      currentVacancyId: null,
      MODULE,
      module: MODULE.CANDIDATES_MODULE,
      loading: false,
      resumeText: '',
      innerDialog: {
        visible: false,
        subtitle: ''
      }
    };
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.USE_PARSE);
  },
  async created() {
    this.loading = true;
    eventBus.$on('DynamicPage', async intents => {
      let candId = this.candidateId;
      if (
        intents?.module == 'HRPAC_CANDIDATES' &&
        intents?.request?.request_params?.record
      ) {
        candId = intents?.request?.request_params?.record;
      }
      const correctData = await store.dispatch('candidate/getMetadata', candId);

      if (
        correctData === false && // важно чтоб не undefined! TFC-1718
        this.$router.history?.current?.meta?.module == MODULE.CANDIDATES_MODULE
      ) {
        this.$router.push('/candidates');
      } else if (correctData === true) {
        eventBus.$emit(EVENTBUS_EVENTS.RELOAD_TAB, this.getActiveTab.id);
      }
    });

    eventBus.$on(EVENTBUS_EVENTS.USE_PARSE, intents => {
      store.commit('event/setIntents', intents);
      this.parse();
    });

    eventBus.$on(EVENTBUS_EVENTS.ATTACHMENT_SHOW_CONFIRM_POPUP, params => {
      const { status, data } = params;
      const noArrayLength =
        !!data && data.hasOwnProperty('length') && !data.length;

      this.status = status;
      this.blocked_candidates = Object.keys(data);

      if (!noArrayLength) {
        this.innerDialog.subtitle = '';

        for (let id in data) {
          data[id].forEach(vacancy => {
            const mes = `<p data-id="${id}"><span>${vacancy.mes}</span></p>`;
            this.innerDialog.subtitle += mes;
          });
        }
        this.$set(this.innerDialog, 'visible', true);
      }
    });

    // this.checkOfferAccess();
    // this.downloadMetadata();
    const correctData = await store.dispatch(
      'candidate/getMetadata',
      this.candidateId
    );
    if (
      !correctData &&
      this.$router.history?.current?.meta?.module == MODULE.CANDIDATES_MODULE
    ) {
      this.$router.push('/candidates');
    }
    // if (this.metaData) {
    //   this.setButtonsData(this.metaData.buttons_menu);
    //   this.setSubpanelData(this.metaData.subpanels);

    //
    //
    //   const contacts = this.candidateFields.communications.value.filter(
    //     contact =>
    //       !this.config.contactsStructure.excluded.includes(contact.value_type)
    //   );
    //   const vacancies = this.data.map(item => {
    //     return {
    //       ...item,
    //       stage_data: Array.isArray(item.stage_data) ? {} : item.stage_data
    //     };
    //   });

    //   store.commit('candidate/setFields', {
    //     ...this.candidateFields,
    //     communications: {
    //       ...this.candidateFields.communications,
    //       value: contacts
    //     }
    //   });
    //   this.setFieldsData(this.candidateFields, 'candidate');
    //   store.commit('candidate/setVacancyData', [...vacancies]);
    //   store.commit('common/setConfig', this.config);
    //   store.commit('common/setMod', this.mod);
    // }
  },
  mounted() {},
  computed: {
    errorAccess() {
      return store.state.candidate.candidateListData.hasOwnProperty('error')
        ? store.state.candidate.candidateListData.error
        : false;
    },
    getActiveTab() {
      return store.state.subpanels.activeSubpanel[this.module];
    },
    fields() {
      return store.state.candidate.metadata?.bean || {};
    },
    candidatePageLoading() {
      return store.state.candidate.loading || false;
    },
    metaData() {
      return store.state.candidate.metadata?.metadata || {};
    },
    questionnaireData() {
      return store.state.candidate.questionnaireData || {};
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    selectedStage() {
      return store.state.candidate.selectedStage || null;
    },
    vacancyForWindow() {
      return store.state.candidate.vacancyForWindow || null;
    },
    selectedVacancyForOffer() {
      return this.vacancyForWindow &&
        this.vacancyForWindow.dialog == 'form_offer_dialog'
        ? this.vacancyForWindow
        : null;
    },
    selectedVacancyForExit() {
      return this.vacancyForWindow &&
        this.vacancyForWindow.dialog == 'employee_exit_dialog'
        ? this.vacancyForWindow
        : null;
    },
    hasEmail() {
      return this.fields?.communications?.value
        ? this.fields.communications.value.filter(
            ({ value_type }) => value_type === 'email'
          )
        : [];
    },
    getExitData() {
      return (
        this.selectedStage ||
        this.selectedVacancyForExit ||
        this.vacancyData.find(({ stage }) => {
          return (
            Number(stage.show_window_for_data) ||
            Number(stage.show_window_for_new_employ_exit)
          );
        })
      );
    },
    getOfferData() {
      return (
        this.selectedStage ||
        this.selectedVacancyForOffer ||
        this.vacancyData.find(({ stage }) => {
          return Number(stage.show_window_for_offer);
        })
      );
    },
    selectedEvent: {
      get() {
        return (
          store.state.candidate.selectedMeeting || {
            hrpac_candidate_id: this.fields.id
          }
        );
      },
      set(val) {
        store.commit('candidate/setSelectedMeeting', val);
      }
    },
    deletedVacancy() {
      return store.state.candidate.deletedVacancy || null;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    },
    simpleStage() {
      if (!this.selectedStage) return;

      const stage = this.selectedStage.stage;
      const stages = this.selectedStage.stage_data;
      const thisStage = Object.values(stages).find(
        ({ id }) => id == this.selectedStage.this_stage
      );
      const isRejectStage = this.isRejectStage(thisStage, stages);
      const selectedRejection = this.isRejectStage(stage, stages);
      return (
        !Number(stage.show_window_for_offer) &&
        !Number(stage.show_custom_popup) &&
        !Number(stage.show_window_for_data) &&
        !Number(stage.show_window_for_new_employ_exit) &&
        !Number(stage.show_corporate_email_popup) &&
        !isRejectStage &&
        !selectedRejection
      );
    },
    disabledButtons() {
      return {
        'send_pd': this.fields.pd_status?.value === 'accepted'
      }
    }
  },
  methods: {
    closeInnerDialog() {
      this.$set(this.innerDialog, 'visible', false);
    },
    closeCard() {
      store.commit('candidate/setParam', {
        name: 'currentCandidate',
        val: null
      });
      store.commit('vacancy/setParam', {
        name: 'currentVacancyCandidate',
        val: null
      });
      localStorage.setItem('currentUserId', null);
      localStorage.setItem('currentVacancyUserId', null);
      if (
        this.$router.history?.current?.meta?.module == MODULE.CANDIDATES_MODULE
      ) {
        this.$router.push('/candidates');
      }
      //если это карточка кандидата, прикрепленная к вакансии
      //и открыта правая панель, перезагружаем метаданные
      else if (
        this.$router.history?.current?.meta?.module == MODULE.VACANCY_MODULE &&
        store.state.rightPanel.panelMode
      ) {
        const params = {
          action: 'get_RightPanel',
          module: 'HRPAC_SELECTION_STAGE_CANDIDATES_1',
          vacancy_id: this.$route.params.id,
          content_type: 'vac_card'
        };
        let stages = store.state.rightPanel?.metadata?.content?.data;
        if (stages) {
          for (let stage of stages) {
            if (!stage.state) {
              params['hidden_stage_ids'] = stages
                .filter(stage => !stage.state)
                .map(stage => stage.id);
              params['hidden_stage_ids'] = stage.id;
            }
          }
        }
        store.commit('rightPanel/setParam', {
          name: 'panelMode',
          val: 'vacancyPanel'
        });
        store.dispatch('rightPanel/getMetadata', { intentOrRequest: params });
      }
      eventBus.$emit(EVENTBUS_EVENTS.TABLE_SELECTION_CLEAR);
    },
    preload(text) {
      this.resumeText = text;
      this.is_visible.preload_resume = true;
    },
    showNewNotification(message) {
      this.showFullNotification(message);
    },
    setLoading(bool) {
      this.loading = bool;
    },
    async saveSecurityServiceData(params) {
      try {
        await store.dispatch('candidate/saveCustomPopupFields', {
          id_vacancy: this.currentVacancyId,
          params
        });

        this.selectedStage = store.state.candidate.selectedStage;

        this.confirmStageSelect('security_dialog');
      } catch (error) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: `Произошла ошибка: ${error}`,
          type: 'warning'
        });
      }
    },
    prepareVacancies() {
      this.loading = true;
      this.$set(this.config, 'offerStages', {});
      this.$set(this.config, 'exitStages', {});
      const vacancies = this.vacancyData;
      store.commit('candidate/blockApplyVacancies', false);

      const updatedVacancies = [];
      vacancies.forEach(vacancy => {
        const indexes = Object.keys(vacancy.stage_data);
        const badIndexes = indexes.filter((i, idx) => idx + 1 != i);
        const newVacancyData = { ...vacancy };

        // обработка случая, когда по этапам и sort сбились индексы
        if (badIndexes.length) {
          const newData = {};
          Object.values(vacancy.stage_data)
            .sort((x, y) => Number(x.sort) - Number(y.sort))
            .forEach(
              (obj, idx) =>
                (newData[idx + 1] = { ...obj, sort: String(idx + 1) })
            );
          newVacancyData.stage_data = newData;
        }

        const stages = newVacancyData.stage_data;
        // вакансии с текущим, пройденным оффером, кроме текущего отказа
        const offerStages = Object.values(stages)
          .filter(
            stage =>
              Number(stage.show_window_for_offer) &&
              (Number(stage.this_stage) || Number(stage.done)) &&
              !Number(Object.values(stages).slice(-1)[0].this_stage)
          )
          .map(({ id, name }) => `${id}_${name}`);
        this.$set(this.config.offerStages, vacancy.vacancy_id, offerStages);

        // вакансии с текущими завершающими этапами на выход
        const exitStages = Object.values(stages)
          .filter(
            stage =>
              (Number(stage.show_window_for_data) ||
                Number(stage.show_window_for_new_employ_exit)) &&
              (Number(stage.this_stage) || Number(stage.done))
          )
          .map(({ id, name }) => `${id}_${name}`);
        this.$set(this.config.exitStages, vacancy.vacancy_id, exitStages);

        for (let key in stages) {
          if (stages[key].id === vacancy.this_stage) {
            newVacancyData.stage = stages[key];
          }

          // этапы с required_position = bottom
          if (
            stages[key].required_position == 'required_bottom' &&
            !this.isRejectStage(stages[key], stages) &&
            vacancy.this_stage === stages[key].id
          ) {
            store.commit('candidate/blockApplyVacancies', true);
          }
        }

        newVacancyData.loading = false;
        updatedVacancies.push(newVacancyData);
      });

      updatedVacancies
        .filter(item => Object.values(item.stage_data).length)
        .sort((c, n) => {
          const currentItemDate = new Date(c.stage_data['1'].date_start_stage);
          const nextItemDate = new Date(n.stage_data['1'].date_start_stage);

          return currentItemDate < nextItemDate ? 1 : -1;
        });
      store.commit('common/setConfig', this.config);
      store.commit('candidate/setVacancyData', [...updatedVacancies]);
    },
    checkOfferAccess() {
      // проверка доступа на формирование оффера
      getController({
        params: {
          module: MODULE.HRPAC_OFFERS,
          action: 'check_button',
          element: 'form_offer',
          check_module: MODULE.CANDIDATES_MODULE,
          to_pdf: true
        }
      })
        .then(resp => {
          const access = resp.data === 'ok' || resp.data === 'not found';
          this.$set(this.config, 'hasOfferAccess', access);
          store.commit('common/setConfig', this.config);
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при проверке доступа к офферу',
            'offer access check'
          )
        );
    },
    confirmRejectionData(dialog, form) {
      if (form) {
        store.commit('candidate/setSelectedStage', {
          ...this.selectedStage,
          form
        });
      }

      if (dialog === 'rejection_dialog') {
        this.confirmStageSelect(dialog);
      }

      if (dialog === 'no_rejection_dialog') {
        this.confirmOrShowExitDialog(dialog);
      }
    },
    confirmStageSelect(dialog) {
      const selected = this.selectedStage;

      if (selected) {
        store.commit('candidate/setSelectedStage', {
          ...this.selectedStage,
          loading: true
        });
        const vacancy = this.vacancyData.find(
          ({ vacancy_id }) => vacancy_id == selected.vacancy_id
        );

        if (!this.requestSent) {
          this.$set(vacancy, 'loading', true);
          this.requestSent = true;
          if (dialog) this.setVisibleDialog(dialog, false);

          const params = {
            module: this.module,
            action: 'selection_stage_ajax',
            candidat_id: this.fields.id.value,
            vacancy_id: selected.vacancy_id,
            stage_id: selected.stage.id,
            to_pdf: true
          };

          if (selected.form) {
            for (let key in selected.form) {
              params[key] = selected.form[key];
            }
          }

          getController({ params })
            .then(resp => {
              const errors = resp.data
                ? resp.data.error || resp.data.errors
                : null;
              if (!errors) {
                const { candidateFields, vacancyData } = resp.data;
                const vacancies = vacancyData.map(item => {
                  return {
                    ...item,
                    stage_data: Array.isArray(item.stage_data)
                      ? {}
                      : item.stage_data
                  };
                });

                store.commit('candidate/setFields', candidateFields);
                store.commit('candidate/updateContacts');
                store.commit('candidate/setVacancyData', [...vacancies]);
                this.prepareVacancies();
                this.updateSubpanels([SUBPANEL.ID.COMMENTS, SUBPANEL.ID.AUDIT]);
              } else {
                this.showErrorMessage(errors);
              }
            })
            .catch(err =>
              this.catchError(
                err,
                'Возникла ошибка при смене этапа кандидата',
                'stage select'
              )
            )
            .finally(() => {
              store.commit('candidate/setSelectedStage', null);
              this.requestSent = false;
              this.loading = false;
            });
        }
      }
    },
    async confirmOrShowExitDialog(dialog) {
      const selected = this.selectedStage;

      if (selected) {
        if (Number(selected.stage.show_window_for_education)) {
          if (!this.hasEmail.length) {
            this.showNotification({
              offset: 100,
              showClose: true,
              message:
                'Укажите в средствах связи актуальный e-mail для отправки ссылки на обучение',
              type: 'error'
            });
          } else {
            this.setVisibleDialog('training_dialog', true);
          }
        } else if (
          Number(selected.stage.show_window_for_offer) &&
          this.config.hasOfferAccess
        ) {
          this.setVisibleDialog('form_offer_dialog', true);
        } else if (Number(selected.stage.show_window_for_data)) {
          const stages = Object.values(selected.stage_data);
          const stageIdx = stages.findIndex(
            stage => stage.id === selected.stage.id
          );
          const nextIsAcceptStage = this.isAcceptStage(
            stages[stageIdx + 1],
            selected.stage_data
          );
          const stageType =
            selected.stage.id === PREPARE_TO_EXIT_STAGE && nextIsAcceptStage
              ? STAGE_TYPE_FOR_EXIT_EMPLOYEE.PREPARE_TO_EXIT
              : selected.stage.id === OFFER_STAGE
              ? STAGE_TYPE_FOR_EXIT_EMPLOYEE.OFFER
              : ''; // параметр для ajax

          this.$set(selected, 'stageType', stageType);

          if (selected.stage.show_corporate_email_popup == 1) {
            this.setVisibleDialog('stage_dialog', false);
            this.setVisibleDialog('corporate_email_dialog', true);

            return;
          }

          this.setVisibleDialog('employee_exit_dialog', true);
        } else if (selected.stage.show_custom_popup == 1) {
          this.currentVacancyId = selected.vacancy_id;

          try {
            await store.dispatch('candidate/loadCustomPopupFields', {
              id_vacancy: selected.vacancy_id,
              id_candidate: selected.candidates_id
            });

            try {
              this.setVisibleDialog('stage_dialog', false);
              this.setVisibleDialog('security_dialog', true);

              // store.commit('candidate/setSelectedStage', selected);
            } catch {
              console.error('Ошибка');
            }
          } catch (error) {
            this.showNotification({
              offset: 100,
              showClose: true,
              message: `Произошла ошибка: ${error}`,
              type: 'warning'
            });
          }
        } else if (selected.stage.show_send_questionnaire_popup == 1) {
          this.setVisibleDialog('stage_dialog', false);
          this.sendQuestionnaire();
        } else {
          if (selected.stage.show_corporate_email_popup == 1) {
            this.setVisibleDialog('stage_dialog', false);

            this.setVisibleDialog('corporate_email_dialog', true);

            return;
          }

          this.confirmStageSelect(dialog);
        }
      }
    },
    deleteCandidate() {
      if (!this.vacancyData.length) {
        if (!this.requestSent) {
          this.requestSent = true;
          const params = {
            module: this.module,
            record: this.fields.id.value,
            action: 'delete_json',
            to_pdf: true,
            jsqon_return: 1
          };
          const formData = new FormData();

          for (let key in params) {
            formData.set(key, params[key]);
          }
          this.setVisibleDialog('delete_dialog', false);

          postController({ options: formData })
            .then(resp => {
              if (resp.data && !resp.data.error) {
                if (resp.data.status === 'ok') {
                  window.location.replace(
                    '/index.php?module=HRPAC_CANDIDATES&action=index&parentTab=Основная'
                  );
                }

                if (resp.data.status === 'error') {
                  throw new Error(resp.data.message);
                }
              }
            })
            .catch(err => this.catchError(err, err, 'candidate remove'))
            .finally(() => (this.requestSent = false));
        }
      }
    },
    confirmVacancyRemove() {
      if (!this.requestSent && this.deletedVacancy) {
        this.requestSent = true;
        this.setVisibleDialog('relation_dialog', false);

        getController({
          params: {
            module: this.module,
            action: 'DeleteRelationship',
            record: this.fields.id.value,
            linked_field: 'hrpac_vacancy_hrpac_candidates_1',
            linked_id: this.deletedVacancy.id,
            refresh_page: 1,
            inline: 1,
            ajaxSubpanel: true
          }
        })
          .then(() => {
            store.commit('candidate/setDeletedVacancy');
            location.reload();
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка удаления вакансии',
              'vacancy remove'
            )
          )
          .finally(() => (this.requestSent = false));
      }
    },
    addConfig(configs = {}) {
      for (let key in configs) {
        this.$set(this.config, key, configs[key]);
      }
      store.commit('common/setConfig', this.config);
    },
    async saveContacts(value = null) {
      this.closeDialog('add_contact_dialog');

      if (value) {
        const communications = await store.dispatch('candidate/getFields', {
          fields: ['communications']
        });
        store.commit('candidate/setFields', {
          ...this.fields,
          communications: communications[0]
        });

        store.commit('candidate/updateContacts');
        store.commit('candidate/updateMessengerKey');
      }
    },
    async saveCorpFrom() {
      const communications = await store.dispatch('candidate/getFields', {
        fields: ['communications']
      });
      store.commit('candidate/setFields', {
        ...this.fields,
        communications: communications[0]
      });
      store.commit('candidate/updateContacts');

      if (+this.selectedStage.stage.show_window_for_data) {
        this.setVisibleDialog('corporate_email_dialog', false);
        this.setVisibleDialog('employee_exit_dialog', true);
      } else {
        this.confirmStageSelect('corporate_email_dialog');
      }
    },
    createTag() {
      store.commit('candidate/setVisibleElem', {
        elem: 'tagForm',
        visible: true
      });
    },
    saveResume() {
      this.setVisibleDialog('save_resume', true);
    },
    sendPD() {
      if (!this.hasEmail.length) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message:
            'Невозможно отправить запрос на обработку ПнД, у кандидата не указан e-mail',
          type: 'warning'
        });

        return;
      }

      getController({
        params: {
          module: 'HRPAC_CANDIDATES',
          action: 'send_pd',
          id: this.fields.id.value
        }
      })
        .then(async resp => {
          if (resp.data.result) {
            const pdStatus = this.fields.pd_status.value;

            if (pdStatus == 'not_sent' || pdStatus == 'denied') {
              this.showNotification({
                offset: 100,
                showClose: true,
                message: 'Согласие на обработку ПнД отправлено кандидату',
                type: 'success'
              });
            }

            const statusPD = await store.dispatch('candidate/getFields', {
              fields: ['pd_status']
            });
            store.commit('candidate/setFields', {
              ...this.fields,
              pd_status: statusPD[0]
            });
          }
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при отправке письма-соглашения об обработке ПД',
            'send PD'
          )
        );
    },
    sendQuestionnaire() {
      if (!this.hasEmail.length) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message:
            'Невозможно отправить анкету кадров, у кандидата не указан e-mail',
          type: 'warning'
        });

        return;
      }

      getController({
        params: {
          module: 'HRPAC_CANDIDATES',
          action: 'send_questionnire',
          email: this.hasEmail[0].value,
          candidate_id: this.fields.id.value,
          vacancy_id: this.selectedStage.vacancy_id
        }
      })
        .then(async resp => {
          if (resp.data.status == 'ok') {
            this.confirmStageSelect();
            store.commit('candidate/setParam', {
              name: 'questionnaireData',
              val: resp.data.data
            });
            store.commit('common/setVisibleDialog', {
              name: 'questionnaire_dialog',
              val: true
            });
          } else
            this.showNotification({
              offset: 100,
              showClose: true,
              message: 'Возникла ошибка при отправке анкеты кадров',
              type: 'warning'
            });
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при отправке анкеты кадров',
            'send questionnaire'
          )
        );
    },
    saveEmail() {
      store.commit('subpanels/updateActiveSubpanel', 'communications');
      this.showNotification({
        offset: 100,
        showClose: true,
        message: 'Email отправлен',
        type: 'success'
      });
    }
  },
  components: {
    Button,
    Candidate,
    Dialog,
    FormButtons,
    EmployeeExitDialog,
    OfferDialog,
    RejectionDialog,
    ShareByCandidateDialog,
    SecurityService,
    CorporateEmail,
    VacancyListForm,
    SaveResumeDialog,
    ResumeDialog,
    TrainingDialog,
    QuestionnaireDialog,
    CandidateConsideredDialog
  }
};
</script>
<style lang="scss" scoped>
.candidate-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: $white;
  border-radius: 4px;
  overflow: hidden;

  &__page {
    overflow-y: auto;
  }

  &__top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    border-radius: 4px 4px 0 0;
    max-width: inherit;
    z-index: 2;
    background: white;
    border-bottom: 1px solid $grey8;

    &-close {
      border-left: 1px solid $grey8;
      padding: 24px;
    }

    &-buttons {
      padding: 16px 8px 16px 24px;
    }
  }
}

//@media (max-width: 1199px) {
//  .candidate-card {
//    width: 100%;
//    max-width: 100%;
//    display: grid;
//    grid-template-rows: min-content 1fr;
//  }
//}

//@media (min-width: 1199px) {
//  .candidate-card__page {
//    min-width: 766px;
//    max-width: 766px;
//  }
//}
//
//@media (min-width: 1513px) {
//  .candidate-card__page {
//    min-width: 766px;
//    max-width: 872px;
//  }
//}
</style>
